var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Container',{attrs:{"itemId":_vm.fileId},on:{"loaded":_vm.afterload}},[_c('div',{staticStyle:{"height":"calc(100vh - 5px)","display":"flex","justify-content":"center","align-items":"center","overflow":"auto"}},[(_vm.url)?_c('img',{staticStyle:{"max-width":"100%","max-height":"100%","object-fit":"contain"},attrs:{"src":_vm.url}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }